import Money from './Money';

export default Money;
